/**
 * Cart quantity +/- uses step from data-qty-step (e.g. 3 for Every 3 Months, 2 for Every 2 Months subscribe items).
 * Runs in capture phase so it runs before theme _updateCart (+/- 1).
 */
(function () {
  'use strict';

  function getCartLine(btn) {
    var wrap = btn.closest('[data-qty-container]');
    var line = wrap && wrap.getAttribute('data-cart-line');
    if (line) return parseInt(line, 10);
    var row = btn.closest('[data-cart-item]');
    line = row && row.getAttribute('data-cart-line');
    return line ? parseInt(line, 10) : null;
  }

  function getStep(wrap) {
    if (!wrap) return 1;
    var s = parseInt(wrap.getAttribute('data-qty-step'), 10);
    return isNaN(s) || s < 1 ? 1 : s;
  }

  function refreshCartUi() {
    if (window.app && typeof window.app._getCartData === 'function') {
      window.app._getCartData();
    }
  }

  function postCartChange(line, quantity, wrap) {
    var $row = wrap && window.jQuery ? window.jQuery(wrap).closest('[data-cart-item]') : null;
    if ($row && $row.length) {
      $row.addClass('updating');
      var $inputWrap = window.jQuery(wrap).find('[data-qty-input]').first().parent();
      if ($inputWrap.length) {
        $inputWrap.css({ 'pointer-events': 'none' });
      }
    }
    if (window.app) {
      window.app.isLoading = true;
    }

    var done = function () {
      if ($row && $row.length) {
        $row.removeClass('updating');
        if ($inputWrap && $inputWrap.length) {
          $inputWrap.css({ 'pointer-events': 'inherit' });
        }
      }
      if (window.app) {
        window.app.isLoading = false;
      }
      refreshCartUi();
    };

    if (window.jQuery) {
      window.jQuery
        .post('/cart/change.js', { line: line, quantity: quantity })
        .done(done)
        .fail(done);
      return;
    }

    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      credentials: 'same-origin',
      body: JSON.stringify({ line: line, quantity: quantity }),
    })
      .then(function () {
        done();
      })
      .catch(function () {
        done();
      });
  }

  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target && e.target.closest && e.target.closest('[data-qty-increase], [data-qty-decrease]');
      if (!btn) return;
      var wrap = btn.closest('[data-qty-container]');
      if (!wrap) return;
      var step = getStep(wrap);
      if (step <= 1) return;

      var line = getCartLine(btn);
      if (!line) return;

      var input = wrap.querySelector('[data-qty-input]');
      if (!input) return;

      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      var current = parseInt(input.value, 10);
      if (isNaN(current) || current < 1) current = step;

      var next;
      if (btn.hasAttribute('data-qty-increase')) {
        next = current + step;
      } else {
        next = Math.max(step, current - step);
      }

      input.value = String(next);
      postCartChange(line, next, wrap);
    },
    true
  );
})();
